<mat-card style="width: 90%; max-width: 750px; text-align: left; margin: 60px auto 10px auto;">
  <mat-card-title>
    <span class="mat-display-1">Terms of Service</span>
  </mat-card-title>
  <mat-card-content class="ql-editor" [innerHtml]="termsHtml">

  </mat-card-content>
</mat-card>
